// istanbul ignore file
// TODO APPS-11349-add-coverage-remove-istanbul-ignore
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { Button, ButtonGroup } from '@cld/button';

export const ActionsGroup = styled.div`
  display: flex;
  align-items: center;

  ${Button} {
    margin-left: ${globalTheme.spacing.lg};
  }

  ${ButtonGroup}, ${Button} {
    height: 100%;
  }

  ${ButtonGroup} ${Button}:not(:first-of-type) {
    margin-left: 0;
  }
`;
